<ng-container *ngLet="breakPointObserve$ | async">
  <div class="container" *ngLet="catalogStatistic$ | async">
    <ng-container *ngIf="!(loadingData$ | async) && loadingAllData; else load">
      <ng-container *ngLet="catalogVersionRelease$ | async as versionRelease">
        <app-header></app-header>
        <div class="child-container">
          <router-outlet></router-outlet>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #load>
      <app-loader></app-loader>
    </ng-template>
  </div>
</ng-container>

<ng-template #notFoundMessage>
  <app-error-page-message
    *ngIf="!(loadingData$ | async) && (isError$ | async) && loadingAllData"
    [icon]="icons.NotFound"
    header="APP_ERROR_MESSAGE.RESPONSE_NOT_FOUND"
    message="APP_ERROR_MESSAGE.TRY_CHANGING_SEARCH_TERMS"
  >
    <button class="btn-secondary medium td-n">{{ 'OTHER.RESET_ALL' | translate }}</button>
  </app-error-page-message>
</ng-template>
